import ScrollMagic from "scrollmagic";
import counterAnimation from "../../js/animations/counter/counter";

import "./ecoBanner.scss";

const ecoBanner = () => {
  const allEcoBanner = document.querySelectorAll(".eco-banner");
  if (!allEcoBanner.length) return;

  /* define const co2 per day (kg) */
  const co2PerDay = 450;
  /* define const co2 per hour (kg) */
  const co2PerHour = 450 / 24;

  allEcoBanner.forEach((el) => {
    let startDate = new Date(el.getAttribute("data-time"));
    let today = new Date();

    let diff = Math.abs(today.getTime() - startDate.getTime()) / 3600000;

    let totCo2 = diff * co2PerHour;
    let totCo2Fixed = totCo2.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let dateWrapper = el.querySelector(".start_date");
    // dateWrapper.append(totCo2.toFixed(2));
    dateWrapper.append(totCo2Fixed);

    const controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: el,
      offset: 0,
      triggerHook: 0.8,
      reverse: false,
    })
      .on("enter", () => {
        let innerNumber = el.querySelectorAll(".start_date");
        if (innerNumber.length) {
          innerNumber.forEach((elNum) => {
            setTimeout(counterAnimation(elNum), 20);
          });
        }
      })
      .setClassToggle(el, "animate")
      .addTo(controller);
  });
};

export default ecoBanner;
